import { Outlet } from "react-router-dom";
import { Sidebar } from "./components/Sidebar";

const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex">
      {/* Admin Sidebar */}
      <Sidebar />

      {/* MAin Content */}
      <main className="flex-1 overflow-hidden p-10">
        <div className="h-full overflow-y-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
